/**
 * 已登录应用壳：永久侧栏 + 布局级 RouteGate。
 *
 * Route: `/`、`/workspace/*`、`/settings`、`/admin/*`
 */

import { Suspense } from "react";
import { Outlet } from "react-router";

import { RouteGate } from "@/components/auth/route-guard";
import { AppShell } from "@/components/layout/app-shell";
import { ShellContentTransition } from "@/components/layout/shell-content-transition";
import { useAccessSession } from "@/components/providers/access-session";
import { ContentSlotPending } from "@/components/ui/content-slot-pending";
import { resolveApplicationShellMode } from "@/config/route-policies";
import { useAppI18n } from "@/i18n/context";
import { useAppPathname } from "@/lib/navigation/use-app-pathname";

export function AuthenticatedLayout() {
  const pathname = useAppPathname();
  const { t } = useAppI18n();
  const { platformRole } = useAccessSession();
  const mode = resolveApplicationShellMode(pathname, platformRole);

  return (
    <AppShell mode={mode}>
      {/* 鉴权挂起与已登录路由的 lazy 共用这一次 fallback。 */}
      <Suspense
        fallback={<ContentSlotPending label={t("routeGuard.switching")} />}
      >
        <RouteGate>
          <ShellContentTransition>
            <Outlet />
          </ShellContentTransition>
        </RouteGate>
      </Suspense>
    </AppShell>
  );
}
